/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IEdmModel } from '../../models/i-edm-model';

export interface OdataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Params {
}

export function odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: OdataMetadata$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
  const rb = new RequestBuilder(rootUrl, odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IEdmModel>;
    })
  );
}

odataMetadata$JsonOdataMetadataNoneOdataStreamingTrue.PATH = '/odata/$metadata';
